import React from 'react';
import styles from 'styles/items_list.module.scss';
import Item from './ItemsList_item';
import { EmptyState } from 'components';
import { ReactComponent as NoData } from 'svgs/no_data.svg';

const ItemsList = ({ items, header, actions, emptyState }) => {
	if (!items.length)
		return (
			<EmptyState heading="No Data" Illustration={NoData} action={emptyState.action} noIcon>
				<p>{emptyState.text}</p>
			</EmptyState>
		);
	return (
		<table cellSpacing="0" cellPadding="0">
			<thead className={styles.header}>
				<tr>
					{header.map(item => {
						return (
							<th
								key={item.title}
								className={item.title}
								// style={{
								// 	display: item.title === 'Actions' ? 'none' : null,
								// }}
							>
								{item.title}
							</th>
						);
					})}
				</tr>
			</thead>
			<tbody>
				{items.map((item, index) => (
					<Item header={header} index={index} actions={actions} item={item} key={`item-${item.id}`} />
				))}
			</tbody>
		</table>
	);
};

export default ItemsList;
